import { view } from "../../../views/mapView/MapView";
import {
  bookmarkEventHandlers,
  identifyWebMapBookMarks,
  loadBookmarksFromLocalStorage,
} from "./Utils";

const BookMarksVM = async (view, divElement,mapId) => {
  //lazy load pattern for import library
  const [{ default: Bookmarks }] = await Promise.all([
    await import("@arcgis/core/widgets/Bookmarks"),
  ]);

  //create a bookmark object
  let bookmarkWidget = await view.when(
    (view) => {
      let Widget: any = new Bookmarks({
        view: view,
        container: divElement,
        editingEnabled: true,
        visibleElements: {
          time: false, // don't show the time (h:m:s) next to the date
        },
      });

      const { bookmarks } = Widget;

      //if the map already has bookmarks identify and add source property
      identifyWebMapBookMarks(bookmarks);

      //load bookmarks from local storage
      loadBookmarksFromLocalStorage(bookmarks,mapId);

      //bookmark event handlers
      bookmarkEventHandlers(Widget,mapId);

      return Widget;
    },
    (e) => console.error("failed to load during view.when", e)
  );
  return bookmarkWidget;
};

export default BookMarksVM;
